module.exports = __webpack_public_path__ + "media/images/weather/200_day-72bb510b4636cb0686fe20f50bf009bd.png";